import { useEffect, useState } from "react";

import CountUp from "react-countup";

import { useThunk } from "../../hooks/useThunk";

import {
	fetchTotalDownloads,
	fetchTotalUsers,
	fetchTotalTracks,
} from "../../store/thunks/reports/downloadThunk";

const SummaryCard = ({ title, value }) => (
	<div className="min-w-[220px] w-full h-[90px] rounded-[10px] bg-[#5BAFD710] flex flex-col justify-center items-center">
		<span className="text-[#5BAFD7] font-publicSans font-bold text-[14px] leading-[22px]">
			{title}
		</span>
		<span className="text-[#E3E3E3] font-publicSans font-bold text-[20px] leading-[22px] mt-1 transition-opacity">
			<CountUp
				end={value}
				separator=","
				duration={5}
				preserveValue
				useEasing
			/>
		</span>
	</div>
);

const DownloadsSummary = () => {
	const [doFetchTotalDownloads] = useThunk(fetchTotalDownloads);
	const [doFetchTotalUsers] = useThunk(fetchTotalUsers);
	const [doFetchTotalTracks] = useThunk(fetchTotalTracks);

	const [totalDownloads, setTotalDownloads] = useState(0);
	const [totalUsers, setTotalUsers] = useState(0);
	const [totalTracks, setTotalTracks] = useState(0);

	useEffect(() => {
		const fetchData = async () => {
			const downloads = await doFetchTotalDownloads();
			const users = await doFetchTotalUsers();
			const tracks = await doFetchTotalTracks();

			if (downloads.success) {
				setTotalDownloads(downloads.response.totalDownloads);
			}

			if (users.success) {
				setTotalUsers(users.response.totalUsers);
			}

			if (tracks.success) {
				setTotalTracks(tracks.response.totalTracks);
			}
		};

		fetchData();
	}, [doFetchTotalDownloads, doFetchTotalUsers, doFetchTotalTracks]);

	return (
		<div className="w-full bg-[#111111d6] border border-[#505050] rounded-lg p-5 mb-6">
			<h2 className="text-[#E3E3E3] font-publicSans font-bold text-[20px] mb-5">
				Summary
			</h2>
			<div className="flex flex-row gap-[15px]">
				<SummaryCard title="Total Downloads" value={totalDownloads} />
				<SummaryCard title="Unique Users" value={totalUsers} />
				<SummaryCard title="Unique Tracks" value={totalTracks} />
			</div>
		</div>
	);
};

export default DownloadsSummary;
